import * as React from "react";
const SVGComponent = (props) => (
    <svg style={{ color: '#fff' }} width="23" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.86719 16.0273H3.86719C3.46936 16.0273 3.08783 15.8693 2.80653 15.588C2.52522 15.3067 2.36719 14.9252 2.36719 14.5273V4.02734C2.36719 3.62952 2.52522 3.24799 2.80653 2.96668C3.08783 2.68538 3.46936 2.52734 3.86719 2.52734H6.86719" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.1172 13.0273L15.8672 9.27734L12.1172 5.52734" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15.8672 9.27734H6.86719" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

);
export default SVGComponent;
